<template>
  <v-container fluid class="main-background">
    <v-row>
      <v-col cols="auto">
        <!-- left menu list -->
        <v-list
          theme="dark"
          density="compact"
          bg-color="#3d3d3e"
          class="left-nav-list"
        >
          <v-list-item>
            <v-img
              contain
              :src="$store.getters.logoWhite"
              class="mb-10"
              width="200"
              height="60"
            ></v-img>
          </v-list-item>

          <div v-for="item in menuItems" :key="item.title">
            <v-list-group
              color="white"
              v-if="item.children && canAccess(item)"
              :value="item.title"
            >
              <template v-slot:activator="{ props }">
                <v-list-item v-bind="props">
                  <v-list-item-title class="text-uppercase">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item>
              </template>

              <div v-for="child in item.children" :key="child.title">
                <v-list-item
                  v-if="canAccess(child)"
                  :class="child.styling"
                  :link="child.link !== null"
                  :to="expandedLink(child.link)"
                  @click.stop="onMenuClick(child)"
                >
                  <template v-slot:prepend v-if="child.itemIcon">
                    <v-icon class="mr-2" :disabled="!canAccess(child)">{{
                      child.itemIcon
                    }}</v-icon>
                  </template>
                  <v-list-item-title class="text-uppercase">
                    {{ child.title }}
                    <v-icon :disabled="!canAccess(child)" v-if="child.icon"
                      >{{ child.icon }}</v-icon
                    >
                  </v-list-item-title>
                </v-list-item>
              </div>
            </v-list-group>
            <v-list-item
              v-else
              :disabled="!canAccess(item)"
              :class="item.styling"
              :link="true"
              :to="expandedLink(item.link)"
              @click.stop="onMenuClick(item)"
            >
              <template v-slot:prepend v-if="item.itemIcon">
                <v-icon class="mr-2" :disabled="!canAccess(item)">{{
                  item.itemIcon
                }}</v-icon>
              </template>
              <v-list-item-title class="text-uppercase">
                {{ item.title }}
                <v-icon :disabled="!canAccess(item)" v-if="item.icon"
                  >{{ item.icon }}</v-icon
                >
              </v-list-item-title>
            </v-list-item>
          </div>
        </v-list>
      </v-col>

      <!-- right-hand side content view -->
      <v-col cols="9,auto" class="home-background">
        <v-row>
          <v-col class="ma-0 pa-0">
            <HomeToolbar :numUnreadMessages="numUnreadMessages" />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ma-0 pa-0">
            <router-view
              @unreadMessageCount="onUpdateUnreadMessages"
            ></router-view>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HomeToolbar from "@/components/home/HomeToolbar"

export default {
  components: {
    HomeToolbar
  },
  data() {
    return {
      numUnreadMessages: 0
    }
  },
  async created() {
    this.computeUnreadMessages()
  },
  computed: {
    selectedTenant() {
      return this.$store.getters.selectedTenant
    },
    tenantUid() {
      if (this.selectedTenant !== null) {
        return this.selectedTenant.uid
      }
      return this.$store.getters.tenantRoot?.uid
    },
    menuItems() {
      return [
        {
          title: this.$t("mainMenu.home"),
          itemIcon: "mdi-home",
          link: "/home",
          styling:
            "nav-item-border-bottom nav-item-border-top grab-home-nav-home"
        },
        {
          title: "brokk connect",
          link: null,
          styling: "nav-item-border-bottom",
          children: [
            {
              title: this.$t("tenant.menuItems.map"),
              itemIcon: "mdi-map-marker",
              link: `/tenants/${this.tenantUid}/map`,
              styling:
                "nav-item-border-bottom nav-item-border-top grab-home-nav-map",
              access: "canAccessMap"
            },
            {
              title: this.$t("tenant.menuItems.machines"),
              itemIcon: "mdi-progress-wrench",
              link: `/tenants/${this.tenantUid}/machines`,
              styling: "nav-item-border-bottom grab-home-nav-machines",
              access: "canAccessMachines"
            },
            {
              title: this.$t("tenant.menuItems.users"),
              itemIcon: "mdi-account-multiple",
              link: `/tenants/${this.tenantUid}/users`,
              styling: "nav-item-border-bottom grab-home-nav-users",
              access: "canAccessUsers"
            },
            {
              title: this.$t("tenant.menuItems.reports"),
              itemIcon: "mdi-finance",
              link: `/tenants/${this.tenantUid}/reports`,
              styling: "nav-item-border-bottom grab-home-nav-reports",
              access: "canAccessReports"
            }
          ]
        },
        {
          title: this.$t("tenant.menuItems.fleetAnalytics"),
          link: null,
          styling: "nav-item-border-bottom",
          access: "canReadFleetAnalytics",
          children: [
            {
              title: this.$t("machines.menuItems.dashboard"),
              itemIcon: "mdi-cog-outline",
              link: `/tenants/${this.tenantUid}/fleet_analytics_dashboard`,
              styling: "nav-item-border-bottom grab-home-nav-fleetAnalytics",
              access: "canReadFleetAnalytics"
            },
            {
              title: this.$t("tenant.menuItems.machines"),
              itemIcon: "mdi-progress-wrench",
              link: `/tenants/${this.tenantUid}/fleet_analytics_machines`,
              styling: "nav-item-border-bottom grab-home-nav-fleetAnalytics",
              access: "canReadFleetAnalytics"
            }
          ]
        },
        {
          title: this.$t("mainMenu.documents"),
          link: null,
          styling: "nav-item-border-bottom",
          children: [
            {
              title: this.$t("tenant.menuItems.manuals"),
              itemIcon: "mdi-book-open-variant",
              link: "/documents/manuals",
              styling: "nav-item-border-bottom grab-home-nav-documents",
              access: "canAccessDocuments"
            },
            {
              title: this.$t("documents.menuItems.spareParts"),
              itemIcon: "mdi-file-cog-outline",
              link: "/documents/spare_parts",
              styling:
                "nav-item-border-bottom nav-item-border-top grab-home-nav-service",
              access: "canReadSpareParts"
            }
          ]
        },
        {
          title: this.$t("mainMenu.webshop"),
          itemIcon: "mdi-cart",
          icon: "mdi-open-in-new",
          link: null,
          action: this.onWebshopClicked,
          styling:
            "nav-item-border-bottom nav-item-border-top grab-home-nav-webshop",
          access: "canAccessWebshop"
        },
        {
          title: this.$t("mainMenu.downloads"),
          itemIcon: "mdi-download",
          link: "/downloads",
          styling:
            "nav-item-border-bottom nav-item-border-top grab-home-nav-download",
          access: "canReadDownloads"
        },
        {
          title: this.$t("mainMenu.help"),
          itemIcon: "mdi-help-circle-outline",
          icon: "mdi-open-in-new",
          link: null,
          action: this.onHelpClicked,
          styling: "grab-home-nav-help"
        },
        {
          title: this.$t("users.settings.account.title"),
          itemIcon: "mdi-account",
          link: "/user_account",
          styling: "mt-8 grab-home-nav-user-account"
        }
      ]
    },
    messages() {
      return this.$store.getters.messages
    },
    readMessages() {
      return this.$store.getters.readMessages
    }
  },
  watch: {
    messages() {
      this.computeUnreadMessages()
    },
    readMessages() {
      this.computeUnreadMessages()
    }
  },
  methods: {
    computeUnreadMessages() {
      if (this.messages.length > 0) {
        this.numUnreadMessages = this.messages.length - this.readMessages.length
      }
    },
    expandedLink(link) {
      if (link !== null) {
        return `${link}`
      }
      return undefined
    },
    onMenuClick(item) {
      if (item.action) {
        item.action()
      }
    },
    canAccessMap() {
      return this.$store.getters.canReadMaps
    },
    canAccessMachines() {
      return this.$store.getters.canReadMachines
    },
    canAccessUsers() {
      return this.$store.getters.canReadUsers
    },
    canAccessReports() {
      return this.$store.getters.canReadReports
    },
    canReadFleetAnalytics() {
      return this.$store.getters.canReadFleetAnalytics
    },
    canAccessWebshop() {
      return this.$store.getters.canAccessWebShop
    },
    canReadDownloads() {
      return this.$store.getters.canReadDownloads
    },
    canAccessDocuments() {
      return true
    },
    canReadSpareParts() {
      return this.$store.getters.canReadSpareParts
    },
    canAccess(item) {
      if (item.access && this[item.access] !== undefined) {
        return this[item.access]()
      }
      return true
    },
    onHelpClicked() {
      window.open("#/help", "_blank")
    },
    onWebshopClicked() {
      window.open(this.$store.getters.webshopURL, "_blank")
    },
    onUpdateUnreadMessages(numUnread) {
      this.numUnreadMessages = numUnread
    }
  }
}
</script>

<style>
.left-nav-list .v-list-group__items .v-list-item {
  padding-inline-start: 2rem !important;
}
.left-nav-list .v-list-item__prepend > .v-icon ~ .v-list-item__spacer {
  width: 8px;
}
.left-nav-list,
.left-nav-list .v-list-item-title {
  font-size: 0.825rem;
  font-weight: 500;
  line-height: 1rem;
}
.main-background {
  background-color: hsl(240, 1%, 24%);
  display: flex;
  align-content: stretch;
  min-height: 100%;
}
.home-background {
  background-color: hsl(120, 3%, 94%);
}
.nav-item-border-top {
  border-top: 1px solid hsl(240, 1%, 54%);
}
.nav-item-border-bottom {
  border-bottom: 1px solid hsl(240, 1%, 54%);
}
.nav-item-active {
  background-color: rgba(255, 205, 0) !important;
}
.nav-item-active .v-list-item__title {
  color: black !important;
}
</style>
